import React from 'react';

const TruckLabourMinimumWarningModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#7876A1]/50 p-3 font-instrument">
      <div
        role="dialog"
        aria-modal="true"
        className="relative rounded-2xl shadow-2xl overflow-hidden font-instrument flex flex-col items-center text-center px-6"
        style={{ width: '328px', height: '337.84px', background: '#F6F6F6' }}
      >
        {/* Close button (top-left) */}
        <button
          onClick={onClose}
          aria-label="Close modal"
          className="absolute left-4 top-4 w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600"
        >
          <img src="/Vision Agent Icons/X Icon/XLightpurple.svg" alt="close" />
        </button>

       

        {/* Truck icon */}
        <div className="mt-8 relative">
          <img
            src="/images/MoverIcon.svg" 
            alt="truck icon"
            className="object-contain"
     
          />
        </div>

        {/* Title */}
        <h2 className="mt-4 text-[24px] font-semibold text-[#34318C]">Minimum 2 movers</h2>

        {/* Message */}
        <p className="mt-3 text-[14px] text-[#34318C] font-normal leading-[18px] w-[226px] text-center">
          For this truck, a minimum of <strong>2 movers</strong> is required
        </p>

        {/* Action button */}
        <div className='flex justify-center items-center mt-[37px] w-full'>
          <button
            onClick={onClose}
            aria-label="Got it"
            className="w-full bg-[#34318C] text-white h-[48px] rounded-[15px] font-semibold text-[14px] shadow-sm hover:bg-[#2d2a6b] focus:outline-none focus:ring-2 focus:ring-[#34318C]/30"
            style={{ maxWidth: '280px' }}
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default TruckLabourMinimumWarningModal;
